var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9628 8.08295C11.2046 8.29431 11.4877 8.40002 11.812 8.40002C12.1255 8.40002 12.402 8.29297 12.6412 8.07892C12.8804 7.86487 13 7.57056 13 7.19598C13 6.85889 12.8857 6.57526 12.6571 6.34515C12.4286 6.11505 12.1468 6 11.812 6C11.4717 6 11.1847 6.11505 10.9508 6.34515C10.7169 6.57526 10.6 6.85889 10.6 7.19598C10.6 7.57593 10.7209 7.87158 10.9628 8.08295ZM10 11.4445C10 10.8922 10.4477 10.4445 11 10.4445H12C12.5523 10.4445 13 10.8922 13 11.4445V16C13.5523 16 14 16.4478 14 17C14 17.5523 13.5523 18 13 18H12C11.4477 18 11 17.5523 11 17V12.4445C10.4477 12.4445 10 11.9968 10 11.4445Z",
    fill: "currentColor"
  })));
}

export default SvgInfo;